import React from 'react';
import BridleCards from '../components/BridleCards';
import SizeGuideCarousel from '../components/SizeGuideCarousel';

const StartPage = () => {
    return (
        <div className="bridle-home">
            <img
                className="home-image"
                src="/images/bridlebuilder/temporary_logo.png"
                alt="SmartFit Custom Bridle Builder"
            />

            <h1 className="bridle-headline">SmartFit Custom Bridle Builder</h1>

            <div className="grid-layout">
                <div className="width-2/12"></div>
                <div className="width-8/12">
                    <p>
                        Take the guesswork out of bridle shopping with the SmartFit Custom Bridle Builder by SmartPak!
                        You choose the style, color, and exactly the size you need in each bridle part for a perfect fit
                        that ensures your horse’s comfort.
                    </p>
                    <h2 className="bridle-subheadline">Choose a style to get started</h2>
                </div>
                <div className="width-2/12"></div>
            </div>

            <BridleCards />

            <div className="fit-guide grid-layout">
                <div className="width-2/12"></div>
                <div className="width-8/12">
                    <h2 className="bridle-subheadline">Which style is right for your horse?</h2>
                    <div>
                        <strong>Harwich&#174; Ergonomic Bridle</strong>
                    </div>
                    <p>
                        Available with or without flash, in black or brown. Anatomically contoured noseband and crown
                        avoid pressure on facial nerves, ears, and poll, making it an ideal choice for sensitive horses.
                    </p>
                    <div className="bridle-link">
                        <a
                            className="link"
                            target="_blank"
                            href="https://www.smartpakequine.com/pt/harwich-ergonomic-bridle-by-smartpak-18662"
                            rel="noreferrer"
                        >
                            See full description here
                        </a>
                    </div>

                    <div>
                        <strong>Harwich&#174; Hunter Bridle</strong>
                    </div>
                    <p>
                        Available in standard or wide width. This timeless, classic design with padded monocrown and
                        fancy stitch detailing is perfect for everyday schooling or to stand out in the show ring.
                    </p>
                    <div className="bridle-link">
                        <a
                            className="link"
                            target="_blank"
                            href="https://www.smartpakequine.com/pt/harwich-hunter-bridle-by-smartpak-14449"
                            rel="noreferrer"
                        >
                            See full description here
                        </a>
                    </div>
                    <div className="width-2/12"></div>

                    <h2 className="bridle-subheadline how-to-measure">How to Measure</h2>
                    <p>
                        To find the best size of each bridle piece for your horse, follow instructions on the guides
                        using a soft measuring tape. If you do not have a soft measuring tape, you can mark a piece of
                        string and use that to get your measurements.
                    </p>
                    <SizeGuideCarousel />
                </div>
                <div className="width-2/12"></div>
            </div>
        </div>
    );
};

export default StartPage;
